module.exports = __webpack_public_path__ + "static/media/skill-react.bc6dd3fa.png";